import { NUMBER_DISPLAY_TYPES_OBJ, VALUE_TYPES_OBJ } from "./interface.ts"


export const DEFAULTS = {
    value_type: VALUE_TYPES_OBJ.number,
    value_number_display_type: NUMBER_DISPLAY_TYPES_OBJ.bare,
    value_number_sig_figs: 2,
}
